import React from 'react';
import './about.css';

class About extends React.Component {
    render() {
        return (
            <div className="about-container">
                <header className="about-header">
                    <h1>About Snap Scrap Repeat</h1>
                    <p className="about-subtitle">Inspiring creativity through scrapbooking challenges</p>
                </header>

                <main className="about-main">
                    <section className="about-section">
                        <h2>Our Mission</h2>
                        <p>
                            Snap Scrap Repeat was created to help scrapbookers overcome creative blocks and discover 
                            new ways to tell their stories. Whether you're a seasoned scrapper or just starting your 
                            journey, our challenge generators provide fresh inspiration to spark your creativity.
                        </p>
                    </section>

                    <section className="about-section">
                        <h2>What We Offer</h2>
                        <div className="features-grid">
                            <div className="feature-card">
                                <h3>Recipe Challenges</h3>
                                <p>Get custom combinations of scrapbooking elements that push you to use materials and techniques in new ways.</p>
                            </div>
                            <div className="feature-card">
                                <h3>Pick 5 Challenges</h3>
                                <p>Choose from a curated list of 10 items to create focused, intentional layouts with limited supplies.</p>
                            </div>
                            <div className="feature-card">
                                <h3>This or That</h3>
                                <p>Make quick creative decisions that help you develop your personal scrapbooking style.</p>
                            </div>
                            <div className="feature-card">
                                <h3>Color Challenges</h3>
                                <p>Explore new color palettes and combinations to bring fresh energy to your pages.</p>
                            </div>
                            <div className="feature-card">
                                <h3>Layout Inspiration</h3>
                                <p>Discover new design approaches and composition ideas for your scrapbook pages.</p>
                            </div>
                            <div className="feature-card">
                                <h3>Tic-Tac-Toe Challenges</h3>
                                <p>Complete fun grid-based challenges that combine multiple elements for comprehensive creativity.</p>
                            </div>
                        </div>
                    </section>

                    <section className="about-section">
                        <h2>How It Works</h2>
                        <div className="how-it-works">
                            <div className="step">
                                <div className="step-number">1</div>
                                <div className="step-content">
                                    <h3>Choose Your Challenge</h3>
                                    <p>Select from our variety of challenge generators based on what inspires you today.</p>
                                </div>
                            </div>
                            <div className="step">
                                <div className="step-number">2</div>
                                <div className="step-content">
                                    <h3>Generate Your Prompt</h3>
                                    <p>Click the generate button to receive your unique, randomized challenge prompt.</p>
                                </div>
                            </div>
                            <div className="step">
                                <div className="step-number">3</div>
                                <div className="step-content">
                                    <h3>Create & Share</h3>
                                    <p>Use the challenge as inspiration for your layout, and download your prompt card to keep with your project.</p>
                                </div>
                            </div>
                        </div>
                    </section>

                    <section className="about-section">
                        <h2>Why Challenges?</h2>
                        <p>
                            Creative constraints often lead to the most innovative solutions. By working within the 
                            parameters of a challenge, you're encouraged to think outside your usual patterns and 
                            discover new techniques, color combinations, and design approaches you might never have 
                            considered otherwise.
                        </p>
                        <p>
                            Our challenges are designed to be flexible guidelines rather than strict rules. Feel free 
                            to adapt them to your style, available supplies, and the story you want to tell.
                        </p>
                    </section>

                    <section className="about-section">
                        <h2>Get Started</h2>
                        <p>
                            Ready to break out of your creative routine? Pick a challenge that speaks to you and see 
                            where your creativity takes you. Remember, there's no right or wrong way to interpret a 
                            challenge – the goal is simply to create and have fun!
                        </p>
                        <div className="cta-buttons">
                            <a className="cta-button primary" href="./">Explore Challenges</a>
                            <a className="cta-button secondary" href="./recipe">Try a Recipe Challenge</a>
                        </div>
                    </section>

                    <section className="about-section">
                        <h2>Connect With Us</h2>
                        <p>
                            Join our community of creative scrapbookers! Follow us on social media for inspiration, 
                            tips, and to see how others are using our challenges in their projects.
                        </p>
                        <div className="social-links">
                            <a 
                                href="https://www.instagram.com/snap.scrap.repeat/" 
                                target="_blank" 
                                rel="noopener noreferrer"
                                className="social-link instagram"
                            >
                                <div className="social-icon">📸</div>
                                <div className="social-content">
                                    <h3>Follow on Instagram</h3>
                                    <p>@snap.scrap.repeat - Daily inspiration and challenge examples</p>
                                </div>
                            </a>
                            <a 
                                href="https://www.facebook.com/groups/snapscraprepeat.co.uk" 
                                target="_blank" 
                                rel="noopener noreferrer"
                                className="social-link facebook"
                            >
                                <div className="social-icon">👥</div>
                                <div className="social-content">
                                    <h3>Join Our Facebook Group</h3>
                                    <p>Connect with fellow scrapbookers and share your challenge creations</p>
                                </div>
                            </a>
                        </div>
                        <p>
                            We'd love to see your creations! If you'd like to share your layouts made using our 
                            challenge generators on your own social media, feel free to use the hashtag 
                            <strong> #snapscraprepeat</strong> so we can discover and celebrate your amazing work.
                        </p>
                    </section>
                </main>
            </div>
        )
    }
}

export default About